import { forwardRef } from 'react'
import type { SelectHTMLAttributes, ReactNode } from 'react'
import { cn } from './cn'

export interface SelectProps extends SelectHTMLAttributes<HTMLSelectElement> {
  /** 検証エラー状態。aria-invalid と danger ボーダーを付与 */
  error?: boolean
  children?: ReactNode
}

// border/focus/error 表現は本コンポーネントが確定（利用側 className での上書き対象外）。
// 既存の素の select（border 1px gray-300・角丸・focus:ring-primary）を踏襲しトークン化。
const BASE =
  'w-full px-4 py-2 rounded-field border-[1.5px] bg-white transition-colors ' +
  'focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-1 ' +
  'disabled:opacity-50 disabled:cursor-not-allowed'

const NORMAL = 'border-[#ddd] focus:border-primary focus-visible:ring-primary'
const ERROR = 'border-danger focus:border-danger focus-visible:ring-danger'

/**
 * 単一選択ドロップダウン。
 * label 関連付け（htmlFor/id もしくは aria-label）は利用側責務。
 * aria-invalid / focus リングは本コンポーネントが担保。
 */
export const Select = forwardRef<HTMLSelectElement, SelectProps>(function Select(
  { error = false, className, children, ...rest },
  ref,
) {
  return (
    <select
      ref={ref}
      aria-invalid={error || undefined}
      className={cn(BASE, error ? ERROR : NORMAL, className)}
      {...rest}
    >
      {children}
    </select>
  )
})
